import styled from 'styled-components/macro';
import { Avatar, Flex } from '@cognite/cogs.js';

export const ReplyCommentThreadContainer = styled(Flex)`
  padding-left: 24px;
`;

export const ReplyCommentWrapper = styled(Flex)`
  width: 100%;
`;

export const ReplyCommentAvatar = styled(Avatar)`
  align-self: flex-start;
  margin-right: 8px;
`;
